// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".App__root___CLrOW{min-height:100vh;display:flex;flex-direction:column}.App__appWrapper___G6dm4{flex:1 0}", "",{"version":3,"sources":["webpack://src/component/App/App.scss"],"names":[],"mappings":"AAAA,mBAAM,gBAAgB,CAAC,YAAY,CAAC,qBAAqB,CAAC,yBAAY,QAAQ","sourcesContent":[".root{min-height:100vh;display:flex;flex-direction:column}.appWrapper{flex:1 0}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "App__root___CLrOW",
	"appWrapper": "App__appWrapper___G6dm4"
};
export default ___CSS_LOADER_EXPORT___;
